export default __webpack_public_path__ + "static/media/portfolio-64.9211a043.jpg";